import { configureEditorDependencies as configureUI } from '../ui/ui.js';
import { configureEditorDependencies as configureUIFunctions } from '../ui/ui-functions.js';

let workspacePromise;

const loadEditorWorkspace = () => {
  if (!workspacePromise) {
    workspacePromise = Promise.all([
      import(/* webpackChunkName: "editor-fabric" */ 'fabric'),
      import(
        /* webpackChunkName: "editor-workspace" */ '../../core/matgen-editor.js'
      ),
      import(
        /* webpackChunkName: "editor-workspace" */ '../components/Sidebar/Sidebar.js'
      ),
      import(
        /* webpackChunkName: "editor-pickr" */ '@simonwep/pickr/dist/pickr.es5.min'
      ),
    ])
      .then(([fabricModule, editorModule, sidebarModule, pickrModule]) => {
        const dependencies = {
          fabric: fabricModule.fabric,
          MatgenEditor: editorModule.MatgenEditor,
          Sidebar: sidebarModule.Sidebar,
          Pickr: pickrModule.default || pickrModule,
        };
        configureUI(dependencies);
        configureUIFunctions(dependencies);
        return dependencies;
      })
      .catch(error => {
        workspacePromise = null;
        throw error;
      });
  }

  return workspacePromise;
};

export { loadEditorWorkspace };
